import {
    GET_QUALIFICATION_ALERTS,
    GET_USERS,
    REMOVE_QUAL_ALERT
} from "./types";
import firebase from "firebase/app";

export const getAlerts = () => {
    return dispatch => {
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/subjects/alerts/qualification_expiry`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_QUALIFICATION_ALERTS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_QUALIFICATION_ALERTS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_QUALIFICATION_ALERTS.FAIL });
        }
    };
};
export const getUsers = () => {
    return dispatch => {
        dispatch({ type: GET_USERS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/users/`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_USERS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_USERS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_USERS.FAIL });
        }
    };
};

export const removeQualificationAlert = (uid = false) => {
    return dispatch => {
        dispatch({ type: REMOVE_QUAL_ALERT.REQUEST });
        if (uid)
            try {
                firebase.auth().onAuthStateChanged(user => {
                    if (user) {
                        firebase
                            .database()
                            .ref("subjects/alerts/qualification_expiry/")
                            .child(uid)
                            .remove(error => {
                                if (error) {
                                    dispatch({ type: REMOVE_QUAL_ALERT.FAIL });
                                } else {
                                    dispatch({
                                        type: REMOVE_QUAL_ALERT.SUCCESS
                                    });
                                }
                            });
                    } else {
                        dispatch({ type: REMOVE_QUAL_ALERT.FAIL });
                    }
                });
            } catch (e) {
                dispatch({ type: REMOVE_QUAL_ALERT.FAIL });
            }
        else dispatch({ type: REMOVE_QUAL_ALERT.FAIL });
    };
};
